// extracted by mini-css-extract-plugin
export var style_logo = "MobileHeader-module--style_logo--e732d";
export var style_menu = "MobileHeader-module--style_menu--93a75";
export var style_mobileHeader = "MobileHeader-module--style_mobileHeader--5ea71";
export var style_search = "MobileHeader-module--style_search--9887b";